<template>
  <div>
    <navHeader></navHeader>
    <div class="page_con">
     <sideBar></sideBar>
      <div class="person_list pr20">
        <div v-if="$route.params.index == 0">
          <!--<div class="fr add_person"><img src="" alt="">-->
            <!--<span  @click="toggleAddList" id="addBtn">添加员工</span>-->
            <!--<ul class="add_list" v-show="addSelect" id="addList">-->
              <!--<li class="add_worker"><router-link to="/add/worker/0/edit/-1">添加在职人员</router-link></li>-->
              <!--<li class="add_retire"><router-link to="/add/retire/1/edit/-1">添加退休人员</router-link></li>-->
              <!--<li class="add_leaver"><router-link to="/add/leaver/2/edit/-1">添加离职人员</router-link></li>-->
            <!--</ul>-->
          <!--</div>-->
          <div class="fr add_person"><img src="" alt="">
            <span><router-link to="/add/worker/0/edit/-1">添加在职人员</router-link></span>
          </div>


          <workerList></workerList>
        </div>
        <div v-if="$route.params.index == 1">
          <div class="fr add_person"><img src="" alt="">

            <!--<ul class="add_list" v-show="addSelect" id="addList">-->
              <!--<li class="add_worker"><router-link to="/add/worker/0/edit/-1">添加在职人员</router-link></li>-->
              <!--<li class="add_retire"><router-link to="/add/retire/1/edit/-1">添加退休人员</router-link></li>-->
              <!--<li class="add_leaver"><router-link to="/add/leaver/2/edit/-1">添加离职人员</router-link></li>-->
            <!--</ul>-->
          </div>

          <retireList></retireList>
        </div>
        <div v-if="$route.params.index == 2">
          <div class="fr add_person"><img src="" alt="">

            <!--<ul class="add_list" v-show="addSelect" id="addList">-->
              <!--<li class="add_worker"><router-link to="/add/worker/0/edit/-1">添加在职人员</router-link></li>-->
              <!--<li class="add_retire"><router-link to="/add/retire/1/edit/-1">添加退休人员</router-link></li>-->
              <!--<li class="add_leaver"><router-link to="/add/leaver/2/edit/-1">添加离职人员</router-link></li>-->
            <!--</ul>-->
          </div>

          <leaverList></leaverList>
        </div>
        <pensionParam v-if="$route.params.index == 3"></pensionParam>
        <powerSet v-if="$route.params.index == 4"></powerSet>
        <personalCenter v-if="$route.params.index == 5"></personalCenter>
      </div>
    </div>
  </div>
</template>
<script>
  import navHeader from '../components/header'
  import sideBar from '../components/siderBar'
  import workerList from '../components/workerList'
  import leaverList from '../components/leaverList'
  import retireList from '../components/retireList'
  import pensionParam from '../components/pensionParam'
  import powerSet from '../components/powerSet'
  import personalCenter from '../components/personalCenter'
  export default{
    data(){
      return {
        msg :'hellow word',
        item:'personalCenter',
        addSelect:false
      }
    },
    components:{
      'navHeader':navHeader,
      'sideBar':sideBar,
      'workerList':workerList,
      'retireList':retireList,
      'leaverList':leaverList,
      'pensionParam':pensionParam,
      'powerSet':powerSet,
      'personalCenter':personalCenter
    },
    methods:{
      // toggleAddList:function(){
      //   this.addSelect=!this.addSelect;
      // },
    },
    created:function(){
      let body = document.getElementsByTagName('body')[0];
      body.addEventListener('click',(e)=>{
        if(e.target.id=='addList' || e.target.id=='addBtn'){
          this.addSelect=true;
          return false;
        }else{
          this.addSelect=false;
        }
      },false)
    }

  }
</script>
<style lang="less">
  .page_con{
      display: flex;
    }
  .person_list{
    flex:1;
    margin-left: 250px;
    .add_person{
      position: relative;
      width:100px;
      height:60px;
      span{
        line-height: 60px;
        font-size: 14px;
        cursor: pointer;
      }
      span:hover{
        a{
          color: #33B7FB;
        }
      }
      .add_list{
        position:absolute;
        background-color: #fff;
        z-index: 10;
        bottom:-205%;
        left:50%;
        margin-left: -110px;
        width:158px;
        border:1px solid #e1e7f6;
        padding-top:10px;
        padding-bottom:10px;
        border-radius:5px;
        li{
          width:85%;
          text-align: right;
          height:38px;
          line-height: 38px;
          cursor: pointer;
        }

        /*.add_worker{*/
          /*background: url("../../static/images/worker.png") 20px center no-repeat;*/
          /*background-size: 24px 24px;*/
        /*}*/
        /*.add_worker:hover{*/
          /*background: url("../../static/images/worker-hover.png") 20px center no-repeat;*/
          /*background-size: 24px 24px;*/
          /*a{*/
            /*color: #33B7FB;*/
          /*}*/
        /*}*/


        .add_retire{
          background: url("../../static/images/retire.png") 20px center no-repeat;
          background-size: 24px 24px;
        }
        .add_retire:hover{
          background: url("../../static/images/retire-hover.png") 20px center no-repeat;
          background-size: 24px 24px;
          a{
            color: #33B7FB;
          }
        }
        .add_leaver{
          background: url("../../static/images/leaver.png") 20px center no-repeat;
          background-size: 24px 24px;
        }
        .add_leaver:hover{
          background: url("../../static/images/leaver-hover.png") 20px center no-repeat;
          background-size: 24px 24px;
          a{
            color: #33B7FB;
          }
        }
      }
    }
  }
  #addBtn{
    padding-left: 28px;
    background:url("../../static/images/personInfo.png") left 0 no-repeat;
    background-size: 18px 18px;
  }
  #addBtn:hover{
    color: #00A5FA;
    background:url("../../static/images/personInfo-hover.png") left 0 no-repeat;
    background-size: 18px 18px;
  }
</style>





// WEBPACK FOOTER //
// src/view/list.vue